import { ServiceDetailPage } from '../../components/ServiceDetailPage';
import { SERVICE_NYELVI } from '../../data/content';
import { Helmet } from 'react-helmet-async';

export default function LanguageDisorderPage() {
  return (
    <>
      <Helmet>
        <title>Nyelvi Fejlődési Zavar Kezelése | Mosolytorna</title>
        <meta name="description" content="Komplex logopédiai segítség specifikus nyelvi fejlődési zavar (SNYI) esetén. A sikeres kommunikáció és a nyelvi rendszer felépítése." />
      </Helmet>
      
      <ServiceDetailPage service={SERVICE_NYELVI} />
    </>
  );
}
